import {AsyncPipe} from '@angular/common';
import {Component, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, ReactiveFormsModule, Validators} from '@angular/forms';
import {MatButton} from '@angular/material/button';
import {MatDialogModule, MatDialogRef} from '@angular/material/dialog';
import {MatFormField, MatLabel} from '@angular/material/form-field';
import {MatInput} from '@angular/material/input';
import {MatTooltip} from "@angular/material/tooltip";
import {MarkdownTextareaComponent} from '@app/shared/markdown-textarea/markdown-textarea.component';
import {Stream} from '@app/stream/models';
import {StreamService} from '@app/stream/stream.service';
import {Observable} from 'rxjs';

@Component({
    selector: 'frog-add-review-dialog',
    imports: [
        AsyncPipe,
        MatButton,
        MatDialogModule,
        ReactiveFormsModule,
        MarkdownTextareaComponent,
        MatFormField,
        MatInput,
        MatLabel,
        MatTooltip,
    ],
    templateUrl: './add-review-dialog.component.html',
    styleUrl: './add-review-dialog.component.scss',
})
export class AddReviewDialogComponent implements OnInit {
    public stream$: Observable<Stream>;
    public form: FormGroup;

    constructor(
        private streamService: StreamService,
        private formBuilder: FormBuilder,
        public dialogRef: MatDialogRef<AddReviewDialogComponent>,
    ) {
        this.form = this.formBuilder.group({
            name: ['', Validators.required],
            description: '',
        });
    }

    ngOnInit() {
        this.stream$ = this.streamService.stream;
    }

    public save(streamId: string): void {
        const data = {
            stream: streamId,
            name: this.form.value.name,
            description: this.form.value.description,
        };
        this.dialogRef.close(data);
    }

    createDaily(streamId: string) {
        const today = new Date();
        const name = today.toLocaleDateString('en-US', {
            month: 'short',
            day: 'numeric',
            year: 'numeric'
        });
        const data = {
            stream: streamId,
            name: name,
            description: '',
        };
        this.dialogRef.close(data);
    }
}
